import React from "react";
import { Statistic, Tag } from "antd";

/**
 * retorna el monto de una transaccion con el color correspondiente
 * */
const RenderMontoTransaccion = (transaccion) => {
  let tipos = {
    1: "#3f8600",
    2: "#cf1322",
  };

  return (
    <Statistic
      value={transaccion.monto}
      precision={2}
      valueStyle={{
        color: tipos[transaccion.tipo],
        fontSize: "14px",
      }}
      prefix={"$"}
      suffix="MXN"
    />
  );
};

/**
 * retorna el monto de una transaccion con el color correspondiente
 * */
const RenderMoney = (props) => {
  let {
    monto,
    precision = 2,
    valueStyle = {
      fontSize: "14px",
    },
    prefix = "$",
    suffix = "MXN",
  } = props;

  return (
    <Statistic
      value={monto}
      precision={precision}
      valueStyle={valueStyle}
      prefix={prefix}
      suffix={suffix}
    />
  );
};

/**
 * retorna le tag del estatus de pago de una venta (ecommerce)
 * @param venta - {*}
 */
const renderTagEstatusPagoVenta = (venta) => {
  if (venta.stripe_id) {
    return <Tag color="purple">PAGADO</Tag>;
  }

  return <Tag color="red">PENDIENTE</Tag>;
};

/**
 * retorna le tag del estatus de pago de una venta (ecommerce)
 * @param venta - {*}
 */
const renderTagEstatusEnvioVenta = (venta) => {
  if (venta.enlace_guia_envio) {
    return <Tag color="purple">ENVIADO</Tag>;
  }

  return <Tag color="red">PENDIENTE</Tag>;
};

/**
 *
 *
 * @memberof ListaCompras
 * @method renderEstatusOrdenCompra
 * @description Retorna el estatus de la orden de compra
 */
const renderEstatusOrdenCompra = (estatus) => {
  let estatus_label = {
    0: <Tag color="#facc15">Creada</Tag>,
    1: <Tag color="#1a91ff">Aceptada</Tag>,
    2: <Tag color="#1d4ed8">Confirmada</Tag>,
    3: <Tag color="#facc15">Incompleta</Tag>,
    4: <Tag color="#bef264">Completa</Tag>,
    5: <Tag color="#eab308">En entrega</Tag>,
    6: <Tag color="#eab308">Entregada</Tag>,
    7: <Tag color="#22c55e">Completa</Tag>,
    8: <Tag color="#15803d">Enviada</Tag>,
  };
  return estatus !== null || estatus !== undefined
    ? estatus_label[estatus]
    : "N/A";
};


const RenderSolicitudCompra = (solicitud) => {
  const estatusLabels = {
    0: <Tag color="orange">🟠 Pendiente</Tag>,
    1: <Tag color="green">🟢 Aprobada</Tag>,
    2: <Tag color="red">🔴 Rechazada</Tag>,
    3: <Tag color="gray">⚪ Cancelada</Tag>,
  };

  return estatusLabels[solicitud?.estado_aprobacion] || <Tag color="default">N/A</Tag>;
};


export {
  RenderMontoTransaccion,
  RenderMoney,
  renderTagEstatusPagoVenta,
  renderTagEstatusEnvioVenta,
  renderEstatusOrdenCompra,
  RenderSolicitudCompra
};
